// extracted by css-extract-rspack-plugin
export default {"cls1":"Rating-cls1_dVm","cls2":"Rating-cls2_Lg6 Rating-cls1_dVm"};